import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { SchoolCalendarComponent } from './school-calendar.component';
import { SchoolCalendarDetailComponent } from './school-calendar-detail.component';
import { SchoolCalendarPopupComponent } from './school-calendar-dialog.component';
import { SchoolCalendarDeletePopupComponent } from './school-calendar-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class SchoolCalendarResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'begining,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const schoolCalendarRoute: Routes = [
    {
        path: 'school-calendar',
        component: SchoolCalendarComponent,
        resolve: {
            'pagingParams': SchoolCalendarResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.schoolCalendar.home.title'
        }
    }, {
        path: 'school-calendar/:id',
        component: SchoolCalendarDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.schoolCalendar.home.title'
        }
    }
];

export const schoolCalendarPopupRoute: Routes = [
    {
        path: 'school-calendar-new',
        component: SchoolCalendarPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.schoolCalendar.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'school-calendar/:id/edit',
        component: SchoolCalendarPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.schoolCalendar.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'school-calendar/:id/delete',
        component: SchoolCalendarDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.schoolCalendar.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar.route.ts